<template>
    <VContent>
        <PaymentMethods />
    </VContent>
</template>

<script>

  import PaymentMethods from "@/components/stripe/PaymentMethods";
  export default {
    components: {PaymentMethods},
    name: "Payment",
    data() {
      return {}
    },
    mounted() {
    },
    methods: {}
  }
</script>

<style scoped>

</style>